import axios from 'axios'
import routes from '@configs/api'

export type CreateSupportRequestData = {
  fullName: string
  email: string
  phone: string
  message: string
  type: string
  amountOfCourses?: string
  studentAudience?: string
  country?: string
  action?: string
}

const createSupportRequest = (data: CreateSupportRequestData): Promise<void> => {
  return new Promise((resolve, reject) => {
    const URL = `${routes.SUPPORT}/requests`
    axios
      .post(URL, data)
      .then(() => resolve())
      .catch((err) => reject(err))
  })
}

export default createSupportRequest
